import React from 'react';
import { Box, Paper, Stack, Skeleton } from '@mui/material';

export const CandidateCardSkeleton: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        p: 3,
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: 2.5 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="rounded" width={52} height={52} sx={{ borderRadius: 2 }} />
          <Stack spacing={0.75}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={90} height={16} />
            <Skeleton variant="text" width={70} height={14} />
          </Stack>
        </Stack>
        <Stack alignItems="center" spacing={0.5}>
          <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width={32} height={14} />
        </Stack>
      </Stack>

      <Box sx={{ mb: 2.5 }}>
        <Skeleton variant="text" width={80} height={16} sx={{ mb: 1 }} />
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width={75} height={24} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width={65} height={24} sx={{ borderRadius: 1 }} />
        </Stack>
      </Box>

      <Box sx={{ mb: 2.5 }}>
        <Skeleton variant="text" width={90} height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="100%" height={14} />
        <Skeleton variant="text" width="75%" height={14} />
      </Box>

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 1 }} />
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: 1 }} />
        </Stack>
      </Stack>
    </Paper>
  );
};

export const CandidateTableSkeleton: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ p: 2.5, borderBottom: '1px solid', borderColor: 'grey.100' }}>
        <Skeleton variant="text" width={160} height={24} />
      </Box>
      <Stack divider={<Box sx={{ borderBottom: '1px solid', borderColor: 'grey.100' }} />}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              p: 2.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Skeleton variant="rounded" width={40} height={40} sx={{ borderRadius: 1.5 }} />
              <Stack spacing={0.5}>
                <Skeleton variant="text" width={120} height={18} />
                <Skeleton variant="text" width={90} height={14} />
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={4}>
              <Stack direction="row" spacing={1}>
                <Skeleton variant="rounded" width={60} height={22} />
                <Skeleton variant="rounded" width={60} height={22} />
              </Stack>
              <Skeleton variant="text" width={70} height={16} />
              <Skeleton variant="rounded" width={32} height={32} />
              <Stack direction="row" spacing={0.5}>
                <Skeleton variant="rounded" width={28} height={28} />
                <Skeleton variant="rounded" width={28} height={28} />
              </Stack>
            </Stack>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export const SkeletonGrid: React.FC<{ count?: number }> = ({ count = 10 }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
          '2xl': 'repeat(5, 1fr)',
        },
        gap: 2,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <CandidateCardSkeleton key={index} />
      ))}
    </Box>
  );
};
